import type { IVRInfo } from "../../../../sales-context/SalesContext.types";

// True when there's a summary or product details and no conversational summary.
export function hasStandardIVRInfo({
    summary,
    productLink,
    productTitle,
    conversationalSummary,
}: IVRInfo = {}): boolean {
    return (!!summary || !!productLink || !!productTitle) && !conversationalSummary;
}
